export default function initTenantsPie() {
  const wrap = document.getElementById("tenants-pie-component")
  if (!wrap) return

  // const svgOutlines = document.getElementById("tenants-outlines")
  const svgLogos = document.getElementById("tenants-logos")
  const parts = svgLogos.querySelectorAll(".part")
  const texts = wrap.querySelectorAll(".part-text")
  const logo = wrap.querySelector(".logo")

  parts.forEach((part) => {
    part.addEventListener("mouseover", (el) => {
      mouseOver(el.target.closest(".part").dataset.index)
    })

    part.addEventListener("mouseout", () => {
      mouseOut()
    })
  })

  function mouseOver(index) {

    texts.forEach((text) => {
      text.classList.remove("active")
    })

    parts.forEach((part) => {
      part.classList.remove("active", "unactive")
    })

    parts.forEach((part) => {
      part.classList.add(part.dataset.index === index ? "active" : "unactive")
      const text = wrap.querySelector(`.part-text[data-index=${index}]`)
      const rotate = `rotate(${text.dataset.rotate}deg)`

      text.classList.add("active")

      logo.style.webkitTransform = rotate
      logo.style.mozTransform = rotate
      logo.style.msTransform = rotate
      logo.style.oTransform = rotate
      logo.style.transform = rotate
    })
  }

  function mouseOut() {
    parts.forEach((part) => {
      part.classList.remove("active", "unactive")
    })
    
    texts.forEach((text) => {
      text.classList.remove("active")
    })
    
    const rotate = "rotate(0deg)"
    logo.style.webkitTransform = rotate
    logo.style.mozTransform = rotate
    logo.style.msTransform = rotate
    logo.style.oTransform = rotate
    logo.style.transform = rotate
    
    // Set the first element to active
    if (parts.length > 0) {
      parts[2].classList.add("active")
      parts[1].classList.add("unactive")
      parts[0].classList.add("unactive")
      texts[0].classList.add("active")
    }
  }
}
